/* eslint-disable jsx-a11y/interactive-supports-focus */
import React from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';
import Box from '@material-ui/core/Box';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import { shouldUpdate } from 'recompose';
import NavBarContainerNew from '../../../containers/PageStructure/NavBar/NavBarContainerNew';
import CommunityDatePicker from '../../../containers/common/NewDatePicker/CommunityDatePickerContainer';
import globals from '../../../globals/communityGlobals';
import { menuItems } from '../../PageStructure/NavBar/menuItems';
import { ENABLE_MILEAGE_CAP } from '../../../settings/constants/appSettings';

const locale = globals.getArea('header');
const { basename } = globals.urls;

class HeaderNew extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      anchorEl: null,
      showNavBar: true,
      showDatePicker: false,
    };
  }

  componentDidMount() {
    this.props.getAppSettings(ENABLE_MILEAGE_CAP);
  }

  onCollapseChange = () => {
    this.setState({
      showNavBar: !this.state.showNavBar,
    });

    const funcExist = window.recalculate && typeof window.recalculate === 'function';
    if (funcExist) setTimeout(window.recalculate, 50);
  };
  getSelectedMenu = () => {
    if (this.props.currentPathname !== null) {
      const firstLevelItem = menuItems.find(item => this.props.currentPathname.indexOf(item.url) === 0);
      const firstLevelItemExact = menuItems.find(item => this.props.currentPathname === item.url);
      let secondLevelItem = firstLevelItem.children.find(item => this.props.currentPathname.indexOf(item.url) === 0);
      if (firstLevelItemExact) {
        secondLevelItem = firstLevelItem.children[0];
      }

      return `${firstLevelItem.text} ${secondLevelItem ? ` > ${secondLevelItem.text}` : ''}`;
    }
    return null;
  };
  handleLogout = () => {
    this.props.logoutAndRedirect();
  };

  handleClick = event => {
    event.preventDefault();
    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    const { name, currentPathname } = this.props;
    const imageSource = `${basename}images/branding/eCommunity-logo.png`;
    const iconSource = `${basename}images/branding/rldatix-logo-icon.svg`;
    const altText = locale.getMsg('applicationLogo');
    const logOutText = locale.getMsg('logout');
    const showCalendarButton =
      currentPathname != null && (currentPathname.includes('DailyPlanning') || currentPathname.includes('Planner'));
    return (
      <header className="page-header">
        <Box className="header" display="flex" alignItems="flex-end" px={2} py={0.5}>
          <Box flexGrow={1} display="flex" alignItems="center">
            {!this.state.showNavBar && (
              <React.Fragment>
                <div className="logo-wrapper">
                  <img className="logo-icon" alt={altText} src={iconSource} />
                </div>
                <IconButton
                  className="collapse-btn"
                  size="small"
                  aria-label="Expand More"
                  onClick={this.onCollapseChange}
                >
                  <ExpandMoreIcon />
                </IconButton>
              </React.Fragment>
            )}
            {this.state.showNavBar ? (
              <div className="logo-wrapper">
                <img className="logo-icon" alt={altText} src={iconSource} />
                <img className="logo-name" alt={altText} src={imageSource} />
              </div>
            ) : (
              <span style={{ color: 'white', paddingLeft: '5px' }}>{this.getSelectedMenu() || ''}</span>
            )}
          </Box>
          <Box flexGrow={1} alignItems="center" justifyContent="center">
            {showCalendarButton && (
              <div className="datepicker-icon-container">
                <div
                  id="main-header-calendar-button"
                  role="button"
                  tabIndex={0}
                  onClick={() => this.setState({ showDatePicker: !this.state.showDatePicker })}
                  className="datepicker-icon"
                />
                <span>{this.props.selectedDate && this.props.selectedDate}</span>
              </div>
            )}
            {this.state.showDatePicker && (
              <CommunityDatePicker close={() => this.setState({ showDatePicker: false })} />
            )}
          </Box>

          {name && (
            <Box className="action-area" display="flex" justifyContent="flex-end" flexGrow={1}>
              <Button
                size="small"
                color="primary"
                onClick={this.handleClick}
                endIcon={<span className="icon-extend icon-person" />}
              >
                {name}
              </Button>

              <Menu
                id="menu-appbar"
                anchorEl={this.state.anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={this.state.open}
                onClose={this.handleRequestClose}
              >
                {this.props.isAuthenticated ? (
                  <MenuItem onClick={this.handleLogout}>{logOutText}</MenuItem>
                ) : (
                  <MenuItem id="signin-header-navlink" to="/SignIn">
                    Login
                  </MenuItem>
                )}
              </Menu>
            </Box>
          )}
        </Box>

        {this.state.showNavBar && (
          <NavBarContainerNew {...this.props} onCollapseChange={value => this.onCollapseChange(value)} />
        )}
      </header>
    );
  }
}

HeaderNew.defaultProps = {
  name: null,
  logoutAndRedirect: () => {},
  getAppSettings: () => {},
  isAuthenticated: false,
  currentPathname: null,
  selectedDate: null,
};

HeaderNew.propTypes = {
  name: PropTypes.string,
  logoutAndRedirect: PropTypes.func.isRequired,
  getAppSettings: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  currentPathname: PropTypes.string,
  selectedDate: PropTypes.string,
};

const checkPropsChange = (props, nextProps) =>
  props.name !== nextProps.name ||
  props.isAuthenticated !== nextProps.isAuthenticated ||
  props.selectedDate !== nextProps.selectedDate;

export default shouldUpdate(checkPropsChange)(HeaderNew);
